module.exports = __webpack_public_path__ + "static/media/girl.ecc65613.png";